import { render, staticRenderFns } from "./CarpoolingCard.vue?vue&type=template&id=a5c913c2&scoped=true&"
import script from "./CarpoolingCard.vue?vue&type=script&lang=js&"
export * from "./CarpoolingCard.vue?vue&type=script&lang=js&"
import style0 from "./CarpoolingCard.vue?vue&type=style&index=0&id=a5c913c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c913c2",
  null
  
)

export default component.exports